import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { useReady } from "../../boot";

/**
 * Weighted, eased wheel scrolling (Lenis), so the pinned scroll scenes glide
 * instead of stepping. Mouse and trackpad only, started once the loader has
 * lifted, and off for reduced motion.
 */
const SmoothScroll = () => {
	const ready = useReady();

	useEffect(() => {
		// Only for mouse/trackpad: touch scrolling is already native and smooth, and
		// Lenis's scroll handlers would just add work on phones.
		const wanted = window.matchMedia("(pointer: fine) and (prefers-reduced-motion: no-preference)").matches;
		if (!ready || !wanted) return undefined;
		const lenis = new Lenis({
			autoRaf: true,
			lerp: 0.1,
			// In-page links (#about, #projects...) glide too; html's scroll-padding
			// already stops them below the navbar.
			anchors: true,
		});
		return () => lenis.destroy();
	}, [ready]);

	return null;
};

export default SmoothScroll;
